import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../components/ConfirmationModal';

interface IProps {
  show: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const DeleteWorkspaceConfirmationModal = observer((props: IProps): ReactElement => {
  return (
    <ConfirmationModal
      showModal={props.show}
      confirmationHeader={'delete_workspace'}
      confirmationQuestion={'delete_confirmation_workspace_message'}
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      confirmationYes={'delete'}
      loaderKey='delete-workspace-button'
    />
  );
});
